<script>
export default {
  name: 'RangeMustache',
  props: {
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  watch: {
    $props: {
      immediate: true,
      handler () {
        this.validateProps()
      }
    }
  },
  computed: {
    lineLeft () {
      const left = (this.start - this.min) / (this.max - this.min) * 100
      return `${left}%`
    },
    lineRight () {
      const right = 100 - (this.end - this.min) / (this.max - this.min) * 100
      return `${right}%`
    },
    lineStyle () {
      return {
        left: this.lineLeft,
        right: this.lineRight
      }
    }
  },
  methods: {
    validateProps () {
      if (this.start < this.min) {
        return console.error('`start` value must be greater or equal than `min` value')
      }
      if (this.end > this.max) {
        return console.error('`end` value must be greater or equal than `max` value')
      }
      if (this.start > this.end) {
        return console.error('`start` value must be lesser or equal than `end` value')
      }
    }
  }
}
</script>

<template>
  <span class="range-mustache">
    <span class="invisible">
      {{ start }}
    </span>
    <span class="range-mustache__mustache flex-grow-1 mx-2">
      <span class="range-mustache__mustache__drawer" :style="lineStyle" :data-start="start" :data-end="end">
        <span class="range-mustache__mustache__drawer__line"></span>
      </span>
    </span>
    <span class="invisible">
      {{ end }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
.range-mustache {
  height: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  --line-color: var(--primary, currentColor);
  --line-height: 1px;

  &__mustache {
    position: relative;

    &__drawer {
      position: absolute;
      top: 0;
      height: 100%;

      &:before, &:after {
        content: "";
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        padding: 0 0.5em;
      }

      &:before {
        content: attr(data-start);
        justify-content: flex-end;
        right: 100%;
      }

      &:after {
        content: attr(data-end);
        justify-content: flex-start;
        position: absolute;
        left: 100%;
      }

      &__line {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        height: var(--line-height);
        background: var(--line-color);
        display: block;
        transform: translateY(-50%);

        &:before, &:after {
          content: "";
          position: absolute;
          top: 50%;
          height: 0.5em;
          border: 0 solid var(--line-color);
          padding: 0 0.25em;
          transform: translateY(-50%);
        }

        &:before {
          justify-content: flex-start;
          left: 100%;
          border-left-width: 1px;
        }

        &:after {
          justify-content: flex-end;
          right: 100%;
          border-right-width: 1px;
        }
      }
    }
  }
}
</style>
